import styled from 'styled-components';

const SaleSubmissonFormStyleWrapper = styled.div`
  h3 {
    font-size: 22px;
    line-height: 45px !important;
    margin-bottom: 20px;
    text-transform: uppercase;
    color: #ffffff;
  }

  p {
    line-height: 45px !important;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 18px;
  }

  .btn_wrapper {
    width: 100%;
    height: 60px;
  }

  .sale_submisson_form {
    padding: 40px 0;
  }

  .payment-review {
    max-width: 100%;
    max-height: 250px;
    border-radius: 8px;
    border: 1px solid #ddd;
    object-fit: contain;
  }

  .payment-review__wrapper {
    margin-top: 10px;
    text-align: center;
  }

  .upload-box {
    position: relative;
    width: 100%;
  }

  .upload-input {
    display: none;
  }

  .upload-label {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 200px;
    border: 2px dashed #ccc;
    border-radius: 10px;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    overflow: hidden;
  }

  .upload-label:hover {
    border-color: #007bff;
  }

  .upload-placeholder {
    text-align: center;
    color: #666;
  }

  .upload-icon {
    font-size: 40px;
    display: block;
    margin-bottom: 8px;
  }

  .upload-text {
    font-size: 14px;
  }

  .upload-preview {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 10px;
  }

  .sale_submisson_user_form {
    input,
    textarea {
      height: 60px;
      width: 100%;
      padding: 8px 21px;
      border: 2px solid rgba(255, 255, 255, 0.15);
      box-sizing: border-box;
      background: Transparent;
      font-family: Inter;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 45px !important;
      color: rgba(255, 255, 255, 0.5);
      margin-bottom: 23px;
      border-radius: 0;

      &:focus {
        outline: 0 !important;
        box-shadow: none;
      }
    }

    textarea {
      resize: none;
      height: 130px;
    }

    label {
      font-family: 'Russo One';
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 45px !important;
      text-transform: uppercase;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  @media (max-width: 991px) {
  }
  @media only screen and (max-width: 575px) {
    h3 {
      font-size: 19px;
    }
    p {
      font-size: 14px;
      line-height: 24px !important;
    }
  }

  .form-error {
    color: #ff5555;
    font-size: 13px;
    margin-top: 4px;
  }

  .form-check {
    display: flex;
    align-items: center;
    gap: 6px; /* spacing for checkbox and label */
    margin: 0;
    padding: 0;
    cursor: pointer;
  }

  .form-check-input {
    width: 16px;
    height: 16px;
    margin: 0;
    flex-shrink: 0;
    vertical-align: middle;
  }

  .form-check-label {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    line-height: 1.4;
    margin-top: 0;
  }
`;

export default SaleSubmissonFormStyleWrapper;
